// import React, { useState } from "react";
// import { db } from "../../firebase";
// import { collection, getDocs, query, where } from "firebase/firestore";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// function ExportExcel() {
//   const [month, setMonth] = useState(new Date().getMonth() + 1); // default current month
//   const [year, setYear] = useState(new Date().getFullYear());

//   const exportData = async () => {
//     try {
//       const start = new Date(year, month - 1, 1);
//       const end = new Date(year, month, 0, 23, 59, 59);

//       const q = query(
//         collection(db, "contacts"),
//         where("createdAtDate", ">=", start),
//         where("createdAtDate", "<=", end)
//       );

//       const snapshot = await getDocs(q);

//       let data = [];
//       if (!snapshot.empty) {
//         data = snapshot.docs.map((doc) => {
//           const d = doc.data();
//           return {
//             Name: d.name || "",
//             Email: d.email || "",
//             Message: d.message || "",
//             Date: d.createdAtDate?.toLocaleString?.() || "",
//           };
//         });
//       }

//       // Always generate Excel (even if empty)
//       const worksheet = XLSX.utils.json_to_sheet(data);
//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");

//       const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//       const blob = new Blob([excelBuffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });

//       saveAs(blob, `Contacts_${month}_${year}.xlsx`);
//     } catch (err) {
//       console.error("Export Error:", err);
//       alert("Error exporting Excel: " + err.message);
//     }
//   };

//   return (
//     <div>
//       <h3>Download Contacts by Month</h3>
//       <select value={month} onChange={(e) => setMonth(parseInt(e.target.value))}>
//         {[...Array(12)].map((_, i) => (
//           <option key={i + 1} value={i + 1}>
//             {i + 1}
//           </option>
//         ))}
//       </select>
//       <input
//         type="number"
//         value={year}
//         onChange={(e) => setYear(parseInt(e.target.value))}
//       />
//       <button onClick={exportData}>
//         Download Excel ({month}/{year})
//       </button>
//     </div>
//   );
// }

// export default ExportExcel;





// import React, { useState } from "react";
// import { db } from "../../firebase";
// import { collection, getDocs, query, where } from "firebase/firestore";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// function ExportExcel() {
//   const [month, setMonth] = useState(new Date().getMonth() + 1); // current month
//   const [year, setYear] = useState(new Date().getFullYear());

//   const exportData = async () => {
//     try {
//       const start = new Date(year, month - 1, 1);
//       const end = new Date(year, month, 0, 23, 59, 59);

//       const q = query(
//         collection(db, "contacts"),
//         where("createdAtDate", ">=", start),
//         where("createdAtDate", "<=", end)
//       );

//       const snapshot = await getDocs(q);

//       let data = [];
//       if (!snapshot.empty) {
//         data = snapshot.docs.map((doc) => {
//           const d = doc.data();
//           return {
//             Name: d.name || "",
//             Email: d.email || "",
//             Message: d.message || "",
//             Date: d.createdAtDate ? new Date(d.createdAtDate) : "",
//           };
//         });
//       }

//       const worksheet = XLSX.utils.json_to_sheet(data);

//       // Force Excel to treat Date column as real Date
//       Object.keys(worksheet).forEach((cell) => {
//         if (worksheet[cell] && worksheet[cell].t === "d") {
//           worksheet[cell].z = "dd/mm/yyyy hh:mm:ss"; // custom date format
//         }
//       });

//       const workbook = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");

//       const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//       const blob = new Blob([excelBuffer], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });

//       saveAs(blob, `Contacts_${month}_${year}.xlsx`);
//     } catch (err) {
//       console.error("Export Error:", err);
//       alert("Error exporting Excel: " + err.message);
//     }
//   };

//   return (
//     <div>
//       <h3>Download Contacts by Month</h3>
//       <label>
//         Month:
//         <select value={month} onChange={(e) => setMonth(parseInt(e.target.value))}>
//           {[...Array(12)].map((_, i) => (
//             <option key={i + 1} value={i + 1}>
//               {i + 1}
//             </option>
//           ))}
//         </select>
//       </label>
//       <label>
//         Year:
//         <input
//           type="number"
//           value={year}
//           onChange={(e) => setYear(parseInt(e.target.value))}
//         />
//       </label>
//       <button onClick={exportData}>
//         Download Excel ({month}/{year})
//       </button>
//     </div>
//   );
// }

// export default ExportExcel;





import React, { useState } from "react";
import { db } from "../../firebase"; // your firebase config
import { collection, getDocs, query, where } from "firebase/firestore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ExportExcel() {
  const [year, setYear] = useState(new Date().getFullYear());

  const exportData = async () => {
    try {
      const start = new Date(year, 0, 1); // Jan 1st of year
      const end = new Date(year, 11, 31, 23, 59, 59); // Dec 31st end of year

      const q = query(
        collection(db, "contacts"),
        where("createdAtDate", ">=", start),
        where("createdAtDate", "<=", end)
      );

      const snapshot = await getDocs(q);

      if (snapshot.empty) {
        alert(`No data found for year ${year}`);
        return;
      }

      // Convert Firestore docs → Excel rows
      const data = snapshot.docs.map((doc) => {
        const d = doc.data();
        return {
          Name: d.name || "",
          Mobile: d.mobile || "",
          Address: d.address || "",
          Breedname: d.breedname || "",
          Age: d.age || "",
          Gender: d.gender || "",
          Service: d.service || "",

          Date: d.createdAtDate?.toDate
            ? d.createdAtDate.toDate() // Firestore Timestamp → JS Date
            : new Date(d.createdAtDate), // If stored as string/Date
        };
      });

      // Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(data);

      // Ensure Excel shows Date correctly
      Object.keys(worksheet).forEach((cell) => {
        if (worksheet[cell] && worksheet[cell].t === "d") {
          worksheet[cell].z = "dd/mm/yyyy hh:mm:ss";
        }
      });

      // Create workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");

      // Generate Excel file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, `Contacts_${year}.xlsx`);
    } catch (err) {
      console.error("Export Error:", err);
      alert("Error exporting Excel: " + err.message);
    }
  };

  return (
    <div>
      <h3>Download Yearly Contacts</h3>
      <input
        type="number"
        value={year}
        onChange={(e) => setYear(parseInt(e.target.value))}
      />
      <button className="excelbutton mt-2" onClick={exportData}>Download Excel ({year}) <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" class="bi bi-cloud-download" viewBox="0 0 16 16">
  <path d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-2.941 1.1c-.757.652-1.153 1.438-1.153 2.055v.448l-.445.049C2.064 4.805 1 5.952 1 7.318 1 8.785 2.23 10 3.781 10H6a.5.5 0 0 1 0 1H3.781C1.708 11 0 9.366 0 7.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383"/>
  <path d="M7.646 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V5.5a.5.5 0 0 0-1 0v8.793l-2.146-2.147a.5.5 0 0 0-.708.708z"/>
</svg></button>
    </div>
  );
}

export default ExportExcel;
